module.exports = __webpack_public_path__ + "static/media/infosys.c59d4872.svg";